import { Role } from './core/auth/auth.types';
import { Navigation } from './core/navigation/navigation.types';
import { SessionListType } from './shared/models/stocktake/session/session-list-type.enum';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appNavigation: Navigation = {
  default: [
    {
      title: 'Operations',
      subtitle: 'Manage daily operations',
      type: 'group',
      meta: {
        roles: [
          Role.Finance,
          Role.FinanceBanking,
          Role.OpsAdmin,
          Role.WineSales,
          Role.CellarManager,
          Role.CellarAssistant,
          Role.Reporting,
          Role.Support,
        ],
      },
      children: [
        {
          title: 'Logistics',
          subtitle: 'Receiving and dispatch',
          type: 'collapsable',
          icon: 'mat_twotone:local_shipping',
          meta: {
            roles: [
              Role.Finance,
              Role.FinanceBanking,
              Role.OpsAdmin,
              Role.WineSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Inbound',
              type: 'basic',
              link: '/logistics/inbound',
            },
            {
              title: 'Outbound',
              type: 'basic',
              link: '/logistics/outbound',
            },
          ],
        },
        {
          title: 'Managed storage',
          subtitle: 'Wine and ancillaries',
          type: 'collapsable',
          icon: 'mat_twotone:view_in_ar',
          meta: {
            roles: [
              Role.Finance,
              Role.FinanceBanking,
              Role.OpsAdmin,
              Role.WineSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Check-in',
              type: 'basic',
              link: '/managed/checkin',
            },
            {
              title: 'Check-out',
              type: 'basic',
              link: '/managed/checkout',
            },
          ],
        },
        {
          title: 'Stocktake',
          subtitle: 'Wine and ancillaries',
          type: 'collapsable',
          icon: 'mat_twotone:inventory',
          meta: {
            roles: [
              Role.Finance,
              Role.FinanceBanking,
              Role.OpsAdmin,
              Role.WineSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Site (Bottle)',
              type: 'basic',
              link: `/stocktake/${SessionListType.Site}/sessions`,
            },
            {
              title: 'Site (Cases)',
              type: 'basic',
              link: `/stocktake/${SessionListType.Case}/sessions`,
            },
            {
              title: 'Client (Bottle)',
              type: 'basic',
              link: `/stocktake/${SessionListType.Client}/sessions`,
            },
            {
              title: 'Spot (Bottle)',
              type: 'basic',
              link: `/stocktake/${SessionListType.Spot}/sessions`,
            },
            {
              title: 'Stocktake wizard',
              type: 'basic',
              link: '/stocktake/stocktake-create-wizard', //TODO: This will need to be changed
            },
          ],
        },
        {
          title: 'Clients',
          subtitle: 'Manage clients',
          type: 'collapsable',
          icon: 'mat_twotone:person',
          meta: {
            roles: [
              Role.Finance,
              Role.FinanceBanking,
              Role.OpsAdmin,
              Role.WineSales,
              Role.StorageSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Clients',
              type: 'basic',
              link: '/client-accounts',
            },
          ],
        },
        {
          title: 'Billing',
          subtitle: 'Manage billing',
          type: 'collapsable',
          icon: 'mat_twotone:attach_money',
          meta: {
            roles: [
              Role.Finance,
              Role.FinanceBanking,
              Role.OpsAdmin,
              Role.WineSales,
              Role.StorageSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Invoices',
              type: 'basic',
              link: '/billing/invoices',
            },
            {
              title: 'Remittances',
              type: 'basic',
              link: '/billing/remittances',
            },
            {
              title: 'Payments',
              type: 'basic',
              link: '/billing/payments',
            },
            {
              title: 'Activity',
              type: 'basic',
              link: '/billing/activity',
            },
            {
              title: 'Rate cards',
              type: 'basic',
              link: '/billing/rate-cards',
            },
            {
              title: 'Delivery fees',
              type: 'basic',
              link: '/billing/delivery-fees',
              meta: {
                roles: [
                  Role.Finance,
                  Role.FinanceBanking,
                  Role.OpsAdmin,
                  Role.WineSales,
                  Role.CellarManager,
                  Role.CellarAssistant,
                  Role.Reporting,
                  Role.Support,
                ],
              },
            },
            {
              title: 'Reports',
              type: 'basic',
              link: '/billing/finance-reports',
              meta: {
                roles: [
                  Role.Finance,
                  Role.FinanceBanking,
                  Role.OpsAdmin,
                  Role.CellarManager,
                  Role.Reporting,
                  Role.Support,
                ],
              },
            },
          ],
        },
        {
          title: 'Stock management',
          subtitle: 'Manage stock',
          type: 'collapsable',
          icon: 'mat_twotone:assignment',
          meta: {
            roles: [
              Role.Finance,
              Role.OpsAdmin,
              Role.WineSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Cases and pallets',
              type: 'basic',
              link: '/stock-management/containers',
            },
            {
              title: 'Container types',
              type: 'basic',
              link: '/stock-management/container-types',
              meta: {
                roles: [
                  Role.Finance,
                  Role.OpsAdmin,
                  Role.CellarManager,
                  Role.CellarAssistant,
                  Role.Reporting,
                  Role.Support,
                ],
              },
            },
            {
              title: 'Bottle sizes',
              type: 'basic',
              link: '/stock-management/bottle-sizes',
            },
          ],
        },
      ],
    },
    {
      title: 'E-commerce',
      subtitle: 'Manage online shopping',
      type: 'group',
      children: [
        {
          title: 'Marketplace',
          subtitle: 'Categories and accessories',
          type: 'collapsable',
          icon: 'mat_twotone:local_mall',
          children: [
            {
              title: 'Listings',
              type: 'basic',
              link: '/marketplace/listings'
            },
            {
              title: 'Categories',
              type: 'basic',
              link: '/marketplace/categories',
              meta: {
                roles: [
                  Role.Finance,
                  Role.FinanceBanking,
                  Role.OpsAdmin,
                  Role.WineSales,
                  Role.StorageSales,
                  Role.CellarManager,
                  Role.CellarAssistant,
                  Role.Support,
                ],
              },
            },
            {
              title: 'Promotion banner',
              type: 'basic',
              link: '/marketplace/promotion-banner',
              meta: {
                roles: [
                  Role.Finance,
                  Role.FinanceBanking,
                  Role.OpsAdmin,
                  Role.WineSales,
                  Role.StorageSales,
                  Role.CellarManager,
                  Role.CellarAssistant,
                  Role.Support,
                ],
              },
            },
          ],
        },
        {
          title: 'Online orders',
          subtitle: 'Sales and delivery',
          icon: 'mat_twotone:shopping_cart',
          type: 'collapsable',
          meta: {
            roles: [Role.OpsAdmin, Role.WineSales, Role.Support],
          },
          children: [
            {
              title: 'Purchaser',
              type: 'basic',
              link: '/marketplace/purchasers',
            },
            {
              title: 'Seller',
              type: 'basic',
              link: '/marketplace/sellers',
            },
          ],
        },
      ],
    },
    {
      title: 'Administration',
      subtitle: 'Manage facilities, wine and users',
      type: 'group',
      children: [
        {
          title: 'Sites',
          subtitle: 'Manage sites',
          type: 'collapsable',
          icon: 'mat_twotone:maps_home_work',
          children: [
            {
              title: 'Sites',
              type: 'basic',
              link: '/sites',
            },
          ],
        },
        {
          title: 'Wine',
          subtitle: 'Manage wine',
          type: 'collapsable',
          icon: 'mat_twotone:wine_bar',
          meta: {
            roles: [
              Role.Finance,
              Role.OpsAdmin,
              Role.WineSales,
              Role.CellarManager,
              Role.CellarAssistant,
              Role.Reporting,
              Role.Support,
            ],
          },
          children: [
            {
              title: 'Wine',
              type: 'basic',
              link: '/wine/types',
            },
            {
              title: 'Varieties',
              type: 'basic',
              link: '/wine/varieties',
            },
            {
              title: 'Producers',
              type: 'basic',
              link: '/wine/producers',
            },
            {
              title: 'Regions',
              type: 'basic',
              link: '/wine/regions',
            },
          ],
        },
        {
          title: 'Control panel',
          type: 'collapsable',
          icon: 'mat_twotone:settings',
          meta: {
            roles: [Role.ITAdmin, Role.Finance, Role.OpsAdmin, Role.Reporting, Role.Support],
          },
          children: [
            {
              title: 'Users',
              type: 'basic',
              link: '/admin/cms-users',
            },
            {
              title: 'Roles',
              type: 'basic',
              link: '/admin/cms-roles',
              meta: {
                roles: [Role.ITAdmin, Role.Finance, Role.OpsAdmin, Role.Support],
              },
            },
          ],
        },
      ],
    },
  ],
};
